<ng-container *ngIf="blog">
  <div *ngIf="headerType === 'feed'" fxLayout="row" fxLayoutGap="8px">
    <div fxLayout="row" fxLayoutAlign="flex-start center" fxLayoutGap="8px">
      <uni-user-avatar
        fxLayoutAlign="start center"
        [user]="blog.author"
        size="micro">
      </uni-user-avatar>
      <h4 [class]="'margin-y-auto font-regular cursor-pointer sparro-grey-800 ' + 
        (cardWidth<=541 ? 'blog-header-text-md' : 'blog-header-text')">
        <a [href]="goToProfile(blog)" target="_blank" class="font-bolder no-decor">
          {{ blog?.author?.first_name | titlecase }} {{ blog?.author?.last_name | titlecase }}
        </a>
          {{ published ? 'published' : 'updated' }}
        <span class="font-bolder">
          <ng-container *ngIf="published; else draftTemplate">
           <span (click)="getDisciplineFilter(blog?.type)">{{ blog?.type?.name }} </span> {{ blog.created_at | timesince }} ago
          </ng-container>
          <ng-template #draftTemplate>
            {{ blog?.type?.name }} {{ blog.updated_at | timesince }} ago
          </ng-template>
        </span>
      </h4>
    </div>

    <div fxLayout="row" fxFlex fxLayoutAlign="flex-end center">
      <button mat-icon-button (click)="toggleBookmark()" matTooltipPosition="above" *ngIf="published"
        matTooltip="{{ blog.bookmark ? 'Remove from collection' : 'Add to collection' }}">
        <i [class]="blog?.bookmark ? 'icon-add-to-collection-fill sparro-orange-600' : 'icon-add-to-collection'"></i>
      </button>

      <ng-container *ngIf="showCardOptions">
        <div [matMenuTriggerFor]="self ? selfMenu : publicMenu" class="pointer">
          <i class="icon-three-vertical-dots-fill font-md fx-contents"></i>
        </div>

        <mat-menu #selfMenu="matMenu">
          <button mat-menu-item (click)="editBlog()">
            <h4 class="margin-0 font-regular sparro-grey-900">Edit</h4>
          </button>
          <button mat-menu-item (click)="deleteBlog()">
            <h4 class="margin-0 font-regular sparro-grey-900">Delete</h4>
          </button>
          <button mat-menu-item *ngIf="blog.slug">
            <h4 (click)="toggleUnlist()" class="margin-0 font-regular sparro-grey-900">
              {{ blog.unlisted ? 'Make public' : 'Make private'}}
            </h4>
          </button>
        </mat-menu>

        <mat-menu #publicMenu="matMenu">
          <button mat-menu-item *ngIf="published" (click)="toggleFollow()">
            <h4 class="margin-0 font-regular sparro-grey-900">
              {{ blog.is_following ? 'Following' : 'Follow' }}
            </h4>
          </button>
          <button mat-menu-item *ngIf="published" (click)="openShareDialog()">
            <h4 class="margin-0 font-regular sparro-grey-900">Share</h4>
          </button>
          <button mat-menu-item (click)="createReport()" *ngIf="!blog.report || blog.report?.status !== 'INITIATED' && published"
            [disabled]="blog.report?.status === 'VERIFIED'">
            <h4 class="margin-0 font-regular sparro-grey-900">{{ blog.report?.status === 'VERIFIED' ? 'Reported' : 'Report' }}</h4>
          </button>
          <button mat-menu-item *ngIf="blog.report?.status === 'INITIATED'" (click)="redactReport()">
            <h4 class="margin-0 font-regular sparro-grey-900">Redact</h4>
          </button>
        </mat-menu>
      </ng-container>
    </div>
  </div>

  <div *ngIf="headerType === 'none'"></div>
</ng-container>
